import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ItemChooserListComponent } from './item-chooser-list.component';



@NgModule({
  declarations: [
    ItemChooserListComponent
  ],
  exports: [
    ItemChooserListComponent
  ],
  imports: [
    CommonModule,
    IonicModule
  ]
})
export class ItemChooserListModule { }
